import React, { useLayoutEffect, useRef, useState } from "react";

// The sub-tests a cart item includes, expanded inline under its "Contains n tests"
// toggle in DocCartView.
//
// This was a TestDetailsPanel that covered the whole cart column until its × was
// pressed; the only thing it added to the row was this list (the row already shows
// the tags, and preparation tips were never populated). Inline, the reviewer keeps
// the rest of the cart in view and can open several items at once.
//
// `includes` is resolved by CartDashboardUtils._mapChildServices into
// { name, zylaSubTestCode, loincCode }; a plain string is tolerated for safety.

// Past this many tests the list scrolls rather than pushing the rest of the cart
// down. It shows that many in full plus PEEK_PX of the next one, so it reads as
// scrollable even where the OS hides scrollbars until you scroll.
const VISIBLE_TESTS = 5;
const PEEK_PX = 10;

const TestIncludesList = ({ includes = [] }) => {
  const listRef = useRef(null);
  const [maxHeight, setMaxHeight] = useState(null);

  // Measured, not a fixed height: a long name or code line wraps in the narrow cart
  // column, so items aren't all the same height.
  useLayoutEffect(() => {
    const list = listRef.current;
    const next = list?.children[VISIBLE_TESTS];
    setMaxHeight(next ? next.offsetTop + PEEK_PX : null);
  }, [includes]);

  if (includes.length === 0) return null;

  return (
    <ul
      ref={listRef}
      className="cdv-cart-subtests"
      style={maxHeight ? { maxHeight, overflowY: "auto" } : undefined}
    >
      {includes.map((item, index) => {
        const isObj = item && typeof item === "object";
        const testName = isObj ? (item.name ?? item.id ?? "") : item;
        const subTestCode = isObj ? item.zylaSubTestCode : "";
        const loincCode = isObj ? item.loincCode : "";
        return (
          <li key={index} className="cdv-cart-subtest">
            <span className="cdv-cart-subtest-name">{testName}</span>
            {(subTestCode || loincCode) && (
              <span className="cdv-cart-subtest-meta">
                {subTestCode && (
                  <span className="cdv-cart-subtest-code">
                    Code: {subTestCode}
                  </span>
                )}
                {loincCode && (
                  <span className="cdv-cart-subtest-code">
                    LOINC: {loincCode}
                  </span>
                )}
              </span>
            )}
          </li>
        );
      })}
    </ul>
  );
};

export default TestIncludesList;
